import {
  OreCardActions,
  OreCardContainer,
  OreCardWrapper,
  OreStack,
  OreText,
} from '@edenredespana/oreneta'
import { FormProvider, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import {
  Step2Actions,
  Step2AddressStoreData,
  Step2ContactData,
  Step2GeneralStoreData,
  Step2TpvsData,
  Step2WelcomePackAddressData,
} from '@/AutoEnrollment/ui/atoms'
import { useAutoEnrollment } from '@/AutoEnrollment/ui/context'
import { Step2Form } from '@/AutoEnrollment/ui/hooks'
import { formTranslation } from '@/Shared/ui/sharedTranslation'
import { createApiStoreRepository } from '@/Store/infrastructure'
import { useStoreController } from '@/Store/ui/hooks'

export const AutoEnrollmentStep2 = (): JSX.Element => {
  const { t } = useTranslation()
  const { getCurrentStepForm } = useAutoEnrollment()

  const form = getCurrentStepForm() as UseFormReturn<Step2Form>

  const { foodTypes } = useStoreController(
    createApiStoreRepository(),
    undefined,
    true,
    true,
  )

  return (
    <FormProvider {...form}>
      <form>
        <OreStack placeContent="stretch" space="large">
          <OreCardContainer>
            <OreCardWrapper>
              <OreStack placeContent="stretch" space="xlarge">
                <Step2GeneralStoreData foodTypes={foodTypes} />
                <Step2AddressStoreData />
                <Step2ContactData />
                <Step2TpvsData />
                <Step2WelcomePackAddressData />
                <OreText>{t(formTranslation.common.requiredFields)}</OreText>
              </OreStack>
            </OreCardWrapper>
            <OreCardActions>
              <Step2Actions />
            </OreCardActions>
          </OreCardContainer>
        </OreStack>
      </form>
    </FormProvider>
  )
}
